/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "Wo5dMEP_BbI",
    title: "Redux Toolkit Tutorial",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "Freecodecamp",
    thumbnail: "https://img.youtube.com/vi/bbkBuqC1rU4/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/bbkBuqC1rU4",
  },
  {
    _id: "F_Riqjdh2oM",
    title: "React JS Crash Course",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "Traversy Media",
    thumbnail: "https://img.youtube.com/vi/w7ejDZ8SWv8/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/w7ejDZ8SWv8",
  },
  {
    _id: "sFuSFo_wihoaf",
    title: "Unreal Engine 5 Tutorial",
    description:
      "Unreal Engine 5 tutorial for beginners! In this free tutorial we will go over everything you need to know to get started in Unreal Engine 5. Specifically we will focus on Unreal's new features: nanite and lumen. You will learn how to install Unreal Engine, navigate the 3D viewport, create materials and worlds, sculpt landscapes, paint foliage, program in Unreal using Blueprints, and end with creating a photorealistic world in real time. ",
    creator: "Unreal Sensei",
    thumbnail: "https://img.youtube.com/vi/gQmiqmxJMtA/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/gQmiqmxJMtA",
  },
  {
    _id: "bMy9g0USMd8",
    title: "2022 Most Satisfying Framework??! This Survey Surprised Me",
    description:
      "Jamstack survey was wild this year! Thank you Netlify for running this every year and sharing the results",
    creator: "Theo - t3 gg",
    thumbnail: "https://img.youtube.com/vi/bMy9g0USMd8/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/bMy9g0USMd8",
  },
  {
    _id: "dCCaYEG5KeA",
    title: "Technologies I'm Learning in 2023",
    description: "Technologies I'm Learning in 2023",
    creator: "Ben Awad",
    thumbnail: "https://img.youtube.com/vi/dCCaYEG5KeA/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/dCCaYEG5KeA",
  },
  {
    _id: "7AMRfNKwuYo",
    title:
      "How Does Live Streaming Platform Work? (YouTube live, Twitch, TikTok Live)",
    description:
      "How Does Live Streaming Platform Work? (YouTube live, Twitch, TikTok Live)",
    creator: "ByteByteGo",
    thumbnail: "https://img.youtube.com/vi/7AMRfNKwuYo/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/7AMRfNKwuYo",
  },
  {
    _id: "fU4o_BKaUZE",
    title: "Build An AI Image Generator With OpenAI & Node.js",
    description:
      "In this project, we will use OpenAI and the DALL-E model to create a web app that will generate images from scratch based on the entered text.",
    creator: "Traversy Media",
    thumbnail: "https://img.youtube.com/vi/fU4o_BKaUZE/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/fU4o_BKaUZE",
  },
  {
    _id: "qwfE7fSVaZM",
    title: "Node.js / Express Course - Build 4 Projects",
    description:
      "Node.js and Express.js are popular technologies used for JavaScript backend web development. In this course, you will improve your skills by building four projects using Node and Express.",
    creator: "Freecodecamp",
    thumbnail: "https://img.youtube.com/vi/qwfE7fSVaZM/maxresdefault.jpg",
    src: "https://www.youtube.com/embed/qwfE7fSVaZM",
  },
];
